//TODO Front Finalizado, falta back-end para baixar os documentos

import React, { useRef, useState } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";
import { formatDate } from "../../../../../../../utils/formatDate";
import { getListDocuments } from "../../../../../../../services/Enterprise/ClickSign/getListDocuments";
import { useQuery } from "react-query";
import { Skeleton } from "primereact/skeleton";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteSignature } from "../../../../../../../services/Enterprise/ClickSign/deleteSignature";
import { patchCancelSignature } from "../../../../../../../services/Enterprise/ClickSign/patchCancelSignature";
import { useAppContext } from "../../../../../../../context/AppContext";
import { getTemporaryUrl } from "../../../../../../../services/File/getTemporaryUrl";

const ClickSignDocuments = ({ id }) => {
  const { permissions } = useAppContext();
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [previewDoc, setPreviewDoc] = useState(null);
  const [selectedItem, setSelectedItem] = useState([]);
  const [visibleTooltip, setVisibleTooltip] = useState(false);
  const [tooltipReverse, setTooltipReverse] = useState(false);
  const [tooltipEnd, setTooltipEnd] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState(null);

  const [top, setTop] = useState(370);

  const [zoom, setZoom] = useState(1);

  const menuRefs = useRef([]);

  const {
    data: documents,
    refetch: refetchDocuments,
    isLoading: isLoadingDocuments,
  } = useQuery({
    queryKey: [`documents${id}`],
    queryFn: () => getListDocuments(id),
    enabled: !!permissions?.includes("54")
  });

  const columns = [
    { field: "id", header: `ID` },
    { field: "name", header: "Nome" },
    {
      field: "doc_signature",
      header: `Assinatura`,
      body: (rowData) => signerBodyTemplate(rowData.signatures, rowData.id),
    },
    {
      field: "status",
      header: `Status`,
      body: (rowData) => statusBodyTemplate(rowData.status),
    },
    {
      field: "created_at",
      header: "Data de Criação",
      body: (rowData) => formatDate(rowData.created_at),
    },
    {
      field: "deadline_at",
      header: "Data de Liberação",
      body: (rowData) => formatDate(rowData.deadline_at),
    },
  ];

  const simplifiedParcels = documents && documents.map(({ client, ...rest }) => rest);

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const handleClose = () => {
    setPreviewDoc(null);
  };

  const statusBodyTemplate = (status) => {
    var result;

    if (status == "signed") {
      result = <span className={`badge bg-success`}>Completo</span>;
    } else if (status == "running") {
      result = <span className={`badge bg-warning`}>Em Processo</span>;
    } else if (status == "deleted") {
      result = <span className={`badge bg-warning`}>Deletado</span>;
    } else if (status == "closed") {
      result = <span className={`badge bg-success`}>Finalizado</span>;
    } else {
      result = <span className={`badge bg-danger`}>Cancelado</span>;
    }
    return result;
  };

  const searchSigners = (event, id) => {
    const rect = event.target.getBoundingClientRect();

    const initialTop = 370;

    setTooltipPosition({
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
    });

    const document = documents.find((doc) => doc.id === id);
    setSelectedItem([document]);
    var endTop = 0;
    var newTop = 0;

    if (document) {
      document.signatures?.forEach((client) => {
        endTop += 30;
      });
    }
    newTop = initialTop + endTop;
    setTop(newTop);
    setVisibleTooltip(true);
  };

  const signerBodyTemplate = (signers, id) => {
    const start = signers?.filter(
      (signer) => signer.status !== "pending"
    ).length;
    const end = signers?.length;

    var result;

    if (start === end) {
      result = (
        <p className={`text-success`}>
          {`${start}/${end}`}{" "}
          <i
            onClick={(event) => searchSigners(event, id)}
            key={id}
            className="fa-regular fa-eye mx-2"
          ></i>
        </p>
      );
    } else {
      result = (
        <p className={`text-warning`}>
          {`${start}/${end}`}{" "}
          <i
            onClick={(event) => searchSigners(event, id)}
            key={id}
            className="fa-regular fa-eye mx-2"
          ></i>
        </p>
      );
    }

    return result;
  };

  const getMenuModel = (rowData) => {
    let menuItems = [];

    if (rowData.status === "running") {
      menuItems = [
        {
          label: "Cancelar",
          icon: "fa-solid fa-xmark",
          command: () => handleOptionSelect("cancel", rowData),
        },
        {
          label: "Baixar",
          icon: "pi pi-fw pi-download",
          items: [
            {
              label: "Original",
              icon: "fa-regular fa-file",
              command: () => handleOptionSelect("original", rowData),
            },
          ]
        },

      ];
    } else if (rowData.status === "completed" || rowData.status === "closed") {
      menuItems = [
        {
          label: "Baixar",
          icon: "pi pi-fw pi-download",
          items: [
            {
              label: "Original",
              icon: "fa-regular fa-file",
              command: () => handleOptionSelect("original", rowData),
            },
            {
              label: "Assinado",
              icon: "fa-solid fa-check",
              command: () => handleOptionSelect("checked", rowData),
            },
            {
              label: "Todos",
              icon: "fa-solid fa-list",
              command: () => handleOptionSelect("all", rowData),
            },
          ],
        },
      ];
    } else if (rowData.status === "canceled") {
      menuItems = [
        {
          label: "Deletar",
          icon: "fa-solid fa-trash",
          command: () => handleOptionSelect("delete", rowData),
        },
      ];
    } else {
      menuItems = [
        {
          label: "Baixar",
          icon: "pi pi-fw pi-download",
          items: [
            {
              label: "Original",
              icon: "fa-regular fa-file",
              command: () => handleOptionSelect("original", rowData),
            },
            {
              label: "Assinado",
              icon: "fa-solid fa-check",
              command: () => handleOptionSelect("checked", rowData),
            },
            {
              label: "Todos",
              icon: "fa-solid fa-list",
              command: () => handleOptionSelect("all", rowData),
            },
          ],
        },
      ];
    }

    return menuItems;
  };

  const getConfirmationMessage = (action) => {
    switch (action) {
      case "cancel":
        return (
          <>
            <strong>Atenção!</strong> Esta ação irá cancelar o contrato. <br />
            Não será mais possível fazer assinaturas. <br />
            Deseja continuar?
          </>
        );
      case "delete":
        return (
          <>
            <strong>Atenção!</strong> Esta ação irá apagar o contrato <br />
            tanto no sistema quanto na ClickSign. <br />
            Deseja continuar?
          </>
        );

      default:
        return "Deseja continuar com esta ação?";
    }
  };


  function downloadPDF(url, fileName) {
    return fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobURL;
        link.setAttribute("download", fileName || "documento.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Erro ao fazer o download do PDF:", error);
        throw error; // importante para o Promise.all
      });
  }

  const extractFileName = (url) => {
    console.log(url);
    const matches = url.match(/\/([^\/?#]+)[^\/]*$/);
    return matches && matches.length > 1 ? matches[1] : "documento.pdf";
  };


  const handleOptionSelect = async (action, rowData) => {
    const confirmationMessage = getConfirmationMessage(action);

    if (["original", "checked", "all"].includes(action)) {
      const notification = toast.loading("Enviando seus dados, por favor aguarde...");

      try {
        const urls = [];

        if ((action === "original" || action === "all") && rowData.file_id) {
          const fileData = await getTemporaryUrl(rowData.file_id);
          urls.push({
            url: fileData.url,
            name: fileData.name ?? "documento.pdf"
          }); 
        }

        if ((action === "checked" || action === "all") && rowData.document_signature_id) {
          const fileData = await getTemporaryUrl(rowData.document_signature_id);
          urls.push({
            url: fileData.url,
            name: fileData.name ?? "documento-assinado.pdf"
          });
        }




        if (urls.length > 0) {
          for (const file of urls) {
            await downloadPDF(file.url, file.name);
          }
          toast.update(notification, {
            render: "Download concluído!",
            autoClose: 5000,
            type: "success",
            isLoading: false,
          });
        } else {
          toast.update(notification, {
            render: "Nenhum documento disponível para download.",
            autoClose: 5000,
            type: "warning",
            isLoading: false,
          });
        }
      } catch (error) {
        console.error(error);
        toast.update(notification, {
          render: "Erro ao processar o download.",
          autoClose: 5000,
          type: "error",
          isLoading: false,
        });
      }

      return;
    }

    if (confirmationMessage) {
      confirmDialog({
        message: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              color: "red",
            }}
          >
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
            ></i>
            <p style={{ margin: 0, textAlign: "center" }}>{confirmationMessage}</p>
          </div>
        ),
        header: (
          <span style={{ color: "red", fontWeight: "bold" }}>Confirmação</span>
        ),
        icon: null,
        acceptLabel: "Sim",
        rejectLabel: "Não",
        acceptClassName: "p-button-danger",
        rejectClassName: "p-button-secondary",
        accept: () => handleConfirmButton(rowData, action),
      });
    }
  };


  // Função para obter referência do menu para cada linha
  const getMenuRef = (index) => {
    if (!menuRefs.current[index]) {
      menuRefs.current[index] = React.createRef();
    }
    return menuRefs.current[index];
  };

  const handleConfirmButton = (rowData, action) => {
    acceptAlter(rowData, action);
  };

  const acceptAlter = async (rowData, action) => {
    let notificationMessage;
    let toastFunction;

    switch (action) {
      case "cancel":
        notificationMessage = "Documento cancelado com sucesso!";
        toastFunction = patchCancelSignature;
        break;

      case "delete":
        notificationMessage = "Documento deletado com sucesso!";
        toastFunction = deleteSignature;
        break;

      default:
        break;
    }

    let notification;
    let errorMessage;

    try {
      notification = toast.loading(
        "Por favor aguarde a ação está sendo realizada..."
      );

      const response = await toastFunction(rowData.id);
      errorMessage =
        response.error && response.error
          ? response.error
          : "Não foi possível fazer a ação.";
      await refetchDocuments();
      toast.update(notification, {
        render: notificationMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      if (errorMessage == undefined) {
        errorMessage = "";
      }
      toast.update(notification, {
        render: "Não foi possível realizar a ação! " + errorMessage,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      await refetchDocuments();
    }
  };

  const getStatusIcon = (status) => {
    if (status == "pending") {
      return <i className="fa-regular fa-clock text-warning"></i>;
    } else {
      return <i className="fa fa-check text-success"></i>;
    }
  };

  const actionBodyTemplate = (rowData, index) => {
    const menuModel = getMenuModel(rowData);
    const menuRef = getMenuRef(index);

    return (
      <div>
        <Button
          icon="pi pi-ellipsis-v"
          className="p-button-rounded p-button-text"
          onClick={(event) => {
            menuRef.current.toggle(event);
          }}
        />
        <TieredMenu
          model={menuModel}
          popup
          className="custom-tieredmenu"
          ref={menuRef}
        />
      </div>
    );
  };

  return (
    <div className="card-border me-2 my-2">
      <div className="container mt-4">
        <div className="title-container">
          <p>
            {" "}
            <i className="fa-solid fa-file-contract me-2"></i> Documentos
            Enviados
          </p>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <div>
            {" "}
            <h4 className="text-success">
              <i className="fa-solid fa-signature mx-2"></i>
              Acompanhar Assinaturas
            </h4>
          </div>
        </div>
        <hr></hr>
        <div className="col-md-12 text-end">
          <span className="p-input-icon-left">
            <i
              className="fa-solid fa-magnifying-glass"
              style={{ fontSize: "16px" }}
            ></i>
            <InputText
              placeholder="Pesquisar"
              className="p-inputtext-sm mb-2 w-100 rounded-4"
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
            />
          </span>
        </div>
        {visibleTooltip && (
          <div
            style={{
              position: "absolute",
              zIndex: "100",
              left: tooltipPosition.left - 299,
              top: tooltipPosition.top - top,
              backgroundColor: "#f2f2f2", // Fundo cinza
              padding: "8px", // Espaçamento interno
              borderRadius: "4px", // Borda arredondada
              boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)", // Sombra
              pointerEvents: "none",
            }}
            className="map-instruction-desktop"
          >
            <div
              style={{
                position: "relative",
                fontSize: zoom > 1 ? "6px" : "16px",
              }}
              className="bg-white px-2 py-1 rounded"
            >
              <div className="d-flex justify-content-end">
                <div
                  onClick={() => setVisibleTooltip(false)}
                  style={{ cursor: "pointer", pointerEvents: "auto" }}
                >
                  <i
                    className="fa-regular text-danger fa-circle-xmark"
                    style={{
                      fontSize: "20px",
                      marginTop: "8px",
                      marginRight: "8px",
                    }}
                  ></i>
                </div>
              </div>
              <div className="d-flex flex-column align-items-left mb-2">
                {selectedItem &&
                  selectedItem.length > 0 &&
                  selectedItem[0].signatures.map((client, index) => (
                    <div key={index} className="d-flex align-items-center my-1">
                      {" "}
                      <div>{getStatusIcon(client.status)}</div>
                      <h6 className="mx-2">{client.email_signer}</h6>
                    </div>
                  ))}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: !tooltipReverse ? "100%" : "", // Posicione o triângulo em relação à parte inferior do elemento pai
                bottom: tooltipReverse ? "100%" : "",
                left: tooltipEnd ? "90%" : "22px", // Centralize o triângulo horizontalmente
                transform: tooltipReverse
                  ? "translateX(-50%) rotate(180deg)"
                  : "translateX(-50%)", // Centralize o triângulo horizontalmente
                width: "0",
                height: "0",
                borderLeft: "10px solid transparent",
                borderRight: "10px solid transparent",
                borderTop: "10px solid #f2f2f2", // A cor do triângulo
              }}
              className="pin-map"
            />
          </div>
        )}
        {isLoadingDocuments ? (
          <Skeleton width="100%" height="240px"></Skeleton>
        ) : (
          <DataTable
            // onMouseMove={updateCursorPosition}
            value={simplifiedParcels}
            selectionMode="checkbox"
            selection={selectedDocuments}
            onSelectionChange={(e) => setSelectedDocuments(e.value)}
            globalFilter={globalFilterValue}
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
                selectionMode={col.selectionMode}
              />
            ))}
            <Column
              key="actions"
              header="Ações"
              body={(rowData, { rowIndex }) =>
                actionBodyTemplate(rowData, rowIndex)
              }
              style={{ width: "150px", textAlign: "center" }}
            />
          </DataTable>
        )}

        {previewDoc && (
          <Dialog
            header="Preview do Documento"
            visible={true}
            style={{ width: "50vw" }}
            onHide={handleClose}
          >
            <p>Visualização do documento {previewDoc.name}</p>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default ClickSignDocuments;
